import { CompareEntryPoint, CompareType } from '@/hotdesk-ui/enum/compare';
import type { CompareConfig } from './types';

/** The design does not support more than 4 columns. */
export const COMPARE_MAX_ITEMS_LIMIT = 4;
/** A comparison needs at least 2 spaces to open. */
export const COMPARE_MIN_ITEMS = 2;

export const DEFAULT_COMPARE_CONFIG: CompareConfig = {
    // Off until the config says otherwise (see getCompareConfig).
    enabled: false,
    maxItems: COMPARE_MAX_ITEMS_LIMIT,
    entryPoints: [
        CompareEntryPoint.EXPLORE,
        CompareEntryPoint.WORKSPACE_DETAILS,
        CompareEntryPoint.LISTING_DETAILS
    ]
};

export const COMPARE_ROUTES: Record<CompareType, string> = {
    [CompareType.WORKSPACE]: '/compare/workspaces',
    [CompareType.LISTING]: '/compare/listings'
};

/** Where the back button goes when there is nothing better. */
export const COMPARE_EXPLORE_PATH = '/workspaces';
